var voted_users_rtlignore_default = {
  "container": "iqsPn",
  "webview": "YI67F",
  "avatar_list": "MKhLF",
  "avatar": "HC7ML",
  "user_avatar": "twn6T",
  "modal": "K8pek",
  "voted_users_modal": "LU3-z",
  "overlay": "tgLwt",
  "user_card": "n93LS",
  "user_name": "XL-Ga",
  "voted_users_modal_header": "YY-yw",
  "cta": "N0Xvd",
  "close_icon": "ye2XF",
  "title": "pH4Gc",
  "member_list_container": "_6frKG",
  "member_list": "jb3OV",
  "loader": "bP3-A",
  "anonymous_counter": "vvhDk",
  "spinner": "_0ptCq",
  "spin": "NR7bw"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
